export default {
  online_payments_off:
    'Bezorging is ingeschakeld, maar klanten kunnen deze niet bestellen: koerierbezorging wordt alleen online betaald en online betalingen zijn uitgeschakeld.',
  gateway_not_verified:
    'Bezorging is ingeschakeld, maar klanten kunnen deze niet bestellen: koerierbezorging wordt alleen online betaald en online betalingen zijn gepauzeerd totdat je betaalaccount is geverifieerd.',
  stripe_processing_fee_missing:
    'Bezorging is ingeschakeld, maar klanten kunnen het niet bestellen: bezorging door koeriers wordt alleen online betaald en online betalingen zijn gepauzeerd totdat je partner de verwerkingskosten instelt.',
  turn_on_online_payments: 'Online betalingen inschakelen',
};
